import { defineStore } from 'pinia'
import state from './state'
import getters from './getters'
import usePaginationStore from '../pagination'
import { ActivitiesApiRequest } from '@/api'
import { ListResponseTypeExpression } from '@/enum/LinqExpressionType'
import { ExpandResponseType } from '@/enum'
import { Activity } from '@/models'

const useActivityStore = defineStore('activities', {
  state: () => state,
  getters,
  actions: {
    async getNotificationsActivities(storeName: string) {
      const listStore = usePaginationStore(storeName)
      const activitiesApi = new ActivitiesApiRequest()
      const options = {
        [ListResponseTypeExpression.Expand]: `${ExpandResponseType.HAULAGE_JOB},${ExpandResponseType.DIGESTATE_JOB},${ExpandResponseType.SPREADING_JOB},${ExpandResponseType.USER}`
      }
      listStore.handleListAPICall<Activity>(
        activitiesApi.getActivitiesList.bind(activitiesApi),
        Activity,
        options
      )
    },
  }
})

export default useActivityStore
